export enum ErrorTag {
  MSAL = 'MSAL',
  API = 'API',
  GOOGLE = 'GOOGLE',
  WEBAPP = 'WEBAPP',
}
